export default __webpack_public_path__ + "2735a3a69b509faf3577afd25bdf552e.woff2";